import { connect } from 'react-redux';
import { fetchWall } from 'arts/actions/wall';
import { addWallToCart, addWallPicturesToCart } from 'arts/actions/cart_items';
import { fetchWalls, resetWalls, fetchWallFilters } from 'arts/actions/walls';
import Wall from './wall';

const mapStateToProps = ({
  wall,
  walls: {
    collection,
    page,
    totalPages,
    loading,
    prevPage
  },
  wallFilters: { filters }
}, { match: { params: { id } } }) => {
  let wallId = parseInt(id, 10);
  let sharingToken = null;
  if (id !== wallId.toString()) {
    if (id === 'style' || id === 'room') {
      wallId = id;
    } else {
      sharingToken = id;
    }
  }
  let w = (collection || []).find(v => v.id === wallId);
  if (collection && collection.length > 0 && !loading && !w && wallId !== 'style' && wallId !== 'room') {
    // fix for the case where the wall is not loaded yet
    if (page > prevPage) {
      // eslint-disable-next-line prefer-destructuring
      w = collection[0];
    } else {
      // eslint-disable-next-line prefer-destructuring
      w = collection[collection.length - 1];
    }
  }
  if (w) {
    return {
      ...w,
      single: false,
      wallFilters: filters,
      walls: collection,
      page,
      hasMore: totalPages > page,
      loading
    };
  }
  const loadedWall = wall[wallId] || wall[sharingToken];
  if (loadedWall) {
    return {
      ...loadedWall,
      single: true,
      sharingToken
    };
  }
  return {
    id: sharingToken ? null : wallId,
    single: true,
    sharingToken
  };
};

export default connect(mapStateToProps, {
  fetchWall, fetchWalls, resetWalls, fetchWallFilters, addWallToCart, addWallPicturesToCart
})(Wall);
